import { Page_Flexiblecontent_Blocks_Pledge } from "graphql";
import SideGraphic from "components/Hero/Fragments/SideGraphic";
import PledgeForm from "features/PledgeForm/PledgeForm";

import React, { useEffect, useRef } from "react";
import { useRouter } from "next/router";
import { animateScroll as scroll, scroller } from "react-scroll";
import { FeaturedImage } from "components/FeaturedImage";
import { Button } from "components/Button";

interface PledgeProps extends Page_Flexiblecontent_Blocks_Pledge {
  className?: string;
}

const DonateBlock = () => {
  return (
    <div className={`overflow-x-clip`}>
      <div className="relative z-0 mx-auto flex min-h-[450px] max-w-screen-2xl flex-col items-center text-center md:flex-row">
        <div className="absolute -left-8 bottom-0 hidden h-full max-h-[90%] w-fit justify-start lg:flex 2xl:left-0">
          <SideGraphic
            className="absolute bottom-0 h-full max-h-[400px]"
            graphic={"donateShihTzu"}
          />
        </div>
        <div className="container z-10 mx-auto mb-56 flex w-full flex-col gap-8 px-4 pb-20 md:mb-auto md:ml-4 md:w-[58vw] lg:mx-auto">
          <PledgeForm />
        </div>
        <div className="absolute -right-8 bottom-0 flex h-full w-fit max-w-[90%] justify-end md:h-full 2xl:right-0">
          <SideGraphic
            className="absolute bottom-0 h-full max-h-[400px] -scale-x-100"
            graphic={"donateAfghan"}
          />
        </div>
      </div>
    </div>
  );
};


const Pledge = ({ className, variant, title, description, pledgeLink, buttonStyle, columnsSplitText, pledgeImage, pledgeItems }: PledgeProps) => {
  const router = useRouter();

  const pledgeBasic = variant && variant === "basic";
  const pledgeSplit = variant && variant === "dual-column";

  useEffect(() => {
    const { animalId, animalName } = router.query;

    if (animalId && animalName) {
      setTimeout(() => {
        scroller.scrollTo("pledge", {
          delay: 0,
          duration: 1000,
          smooth: "easeInOutQuart",
          offset: -157,
        });
      }, 1200);
    }
  }, [router.query]);

  return (
    <section id="pledge" className={`${className ? className : ``}`}>
      {pledgeBasic && (
        <>
          <div className="mx-auto max-w-[1280px] border-t-[1px] border-[#717171] pt-10">
            <div className="mx-auto max-w-[780px] text-center">
              <h2 className="my-4 text-center font-heading text-3xl leading-none text-dark md:text-5xl">
                {title}
              </h2>
              <p className="mb-10 px-10 md:px-0">{description}</p>
            </div>
          </div>
          <DonateBlock />
        </>
      )}
      {pledgeSplit && (
        <div className={`relative grid md:grid-cols-2 gap-8 max-w-[1320px] mx-auto px-4`}>
          <div className={`relative`}>
            {title ? (
              <h2 className="font-heading text-4xl leading-none text-secondary mb-6">
                {title}
              </h2>
            ) : null}
            {pledgeLink && (
              <Button
              href={pledgeLink?.url ?? "#"}
              target={pledgeLink?.target ?? "_self"}
              className={`w-fit md:px-4`}
              variant={buttonStyle as string}
            >
              {pledgeLink?.title}
            </Button>
            )}
            {pledgeImage ? (
              <FeaturedImage
                image={pledgeImage}
                className={`w-full`}
                imgClassName={`max-h-[100%] max-w-[100%] mx-auto mt-6`}
              />
            ) : null}
          </div>
          <div className={`relative`}>
            <div className={`absolute max-md:-top-4 md:-bottom-5 left-0 origin-left z-[2] bg-white py-1 pl-4 pr-8 font-bold font-body md:-rotate-90`}>
              <p>{columnsSplitText}</p>
            </div>
            {pledgeItems && (
              <div className={`relative grid grid-cols-1 gap-4 border-dark border-t-[1px] md:border-l-[1px] pr-4 py-4 pl-4 md:pl-8`}>
                {pledgeItems.map((item, index) => {
                  const { pledgeTitle, pledgeDescription, pledgeIcon} = item ?? {};
                  return (
                    <div key={index} className={`flex flex-col gap-4 max-md:text-center`}>
                      {pledgeIcon ? (
                        <FeaturedImage
                          image={pledgeIcon}
                          className={`w-full`}
                          imgClassName={`max-h-[100%] max-w-[100%] max-md:mx-auto mt-4 mb-2`}
                        />
                      ) : null}
                      {pledgeTitle && (
                        <h3 className="font-heading text-2xl leading-none text-secondary">
                          {pledgeTitle}
                        </h3>
                      )}
                      {pledgeDescription && (
                        <div className="font-body text-dark max-w-[575px]" dangerouslySetInnerHTML={{ __html: pledgeDescription as string }} />
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default Pledge;
